module.exports = __webpack_public_path__ + "static/media/home1_slide1.5f0a4a75.jpg";